// extracted by mini-css-extract-plugin
module.exports = {"background":"_2doMo","overlay":"_26KcC","mobile":"_1adD2"};